module.exports = __webpack_public_path__ + "4ed4c5c6cb2250217611cf26f581d622.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-11.png
// module id = 2656
// module chunks = 0